if (!customElements.get('product-comparison-grid')) {
  class ProductComparisonGrid extends HTMLElement {
    constructor() {
      super();
      this.grid = this.querySelector('.product-comparison-grid');
      this.rows = this.grid.querySelectorAll('tr');
      const count = Number(this.grid.dataset.numProducts) || 2;
      this.grid.style.setProperty('--vrs-comparison-width', Math.max(730, count * 220 + 100) + 'px');
      this.gridContainer = this.querySelector('.product-comparison-container');
      this.showAllButton = this.querySelector('.js-show-all');

      if (this.showAllButton) {
        this.showAllButton.addEventListener('click', this.handleShowAllClick.bind(this));
      }
    }

    connectedCallback() {
      this.slider = this.querySelector('.product-comparison-slider');
      this.nav = this.querySelector('.vrs-comparison-nav');
      if (!this.slider || !this.nav) return;
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.prev = this.nav.querySelector('[data-comparison-prev]');
      this.next = this.nav.querySelector('[data-comparison-next]');
      this.range = this.nav.querySelector('[data-comparison-range]');
      this.updateNavigation = () => {
        const max = Math.max(0, this.slider.scrollWidth - this.slider.clientWidth);
        const position = Math.abs(this.slider.scrollLeft);
        this.nav.hidden = max <= 2;
        this.prev.disabled = position <= 2;
        this.next.disabled = position >= max - 2;
        this.range.value = max ? Math.round(position / max * 100) : 0;
      };
      const direction = () => getComputedStyle(this.slider).direction === 'rtl' ? -1 : 1;
      const advance = step => this.slider.scrollBy({
        left: direction() * step * Math.max(220, this.slider.clientWidth * .7),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      this.prev.addEventListener('click', () => advance(-1), options);
      this.next.addEventListener('click', () => advance(1), options);
      this.range.addEventListener('input', () => {
        this.slider.scrollLeft = direction() * Number(this.range.value) / 100 * (this.slider.scrollWidth - this.slider.clientWidth);
      }, options);
      this.slider.addEventListener('scroll', this.updateNavigation, { ...options, passive: true });
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(this.updateNavigation);
      this.resizeObserver.observe(this.slider);
      this.resizeObserver.observe(this.grid);
      this.updateNavigation();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
    }

    /**
     * Handles 'click' events on the show all rows button
     * @param {object} evt - Event object.
     */
    handleShowAllClick(evt) {
      // Toggle the button text
      const buttonText = evt.target.textContent;
      evt.target.textContent = evt.target.dataset.toggleText;
      evt.target.dataset.toggleText = buttonText;

      // Set the initial max height to transition from
      const gridHeight = this.grid.clientHeight;
      this.gridContainer.style.maxHeight = `${gridHeight}px`;
      this.gridContainer.style.overflow = 'hidden';
      this.gridContainer.classList.add('is-transitioning');

      // Show/hide the relevant rows
      let heightReduction = 0;
      this.rows.forEach((row) => {
        if (row.classList.contains('js-hidden')) {
          row.classList.remove('js-hidden');
          row.dataset.wasHidden = 'true';
        } else if (row.dataset.wasHidden) {
          heightReduction += row.clientHeight;
        }
      });

      this.gridContainer.style.maxHeight = `${heightReduction > 0 ? gridHeight - heightReduction : this.grid.clientHeight}px`;

      // End of max height transition
      setTimeout(() => {
        if (heightReduction > 0) {
          // Hide the rows
          this.rows.forEach((row) => {
            if (row.dataset.wasHidden === 'true') {
              row.classList.add('js-hidden');
              row.removeAttribute('was-hidden');
            }
          });
        }

        // Reset the height back to auto
        this.gridContainer.style.maxHeight = '';
        this.gridContainer.style.overflow = '';
        this.gridContainer.classList.remove('is-transitioning');
      }, (parseFloat(window.getComputedStyle(this.gridContainer).transitionDuration) * 1000));
    }
  }

  customElements.define('product-comparison-grid', ProductComparisonGrid);
}
